import { render, staticRenderFns } from "./packagesAndLoans.vue?vue&type=template&id=36e0f907&scoped=true&"
import script from "./packagesAndLoans.vue?vue&type=script&lang=js&"
export * from "./packagesAndLoans.vue?vue&type=script&lang=js&"
import style0 from "./packagesAndLoans.vue?vue&type=style&index=0&id=36e0f907&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0f907",
  null
  
)

export default component.exports